import theme from './themeConfig'

export default {
  dalmore: {
    title: 'Dalmore',
    showTicketButton: true,
    ...theme.dalmore,
  },
  jura: {
    title: 'Jura',
    showTicketButton: false,
    ...theme.jura,
  },
  fettercairn: {
    title: 'Fettercairn',
    showTicketButton: false,
    ...theme.fettercairn,
  },
  tamnavulin: {
    title: 'Tamnavulin',
    showTicketButton: false,
    ...theme.tamnavulin,
  },
}
